import { PopoverSimpleComponent } from '@1bill-app/components/popover/popover-simple/popover-simple.component';
import { EXPLANATION_NOTES_SIMPLE } from '@1bill-app/constants';
import { BillQuery } from '@1bill-app/services/bill/bill.query';
import { HomeService } from '@1bill-app/services/home/home.service';
import { animate, style, transition, trigger } from '@angular/animations';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { NGXLogger } from 'ngx-logger';
import { map, startWith, switchMap } from 'rxjs/operators';
import { SubSink } from 'subsink';
import { BillService } from './../../services/bill/bill.service';
import { HomeQuery } from './../../services/home/home.query';
import { BillRating } from '@1bill-app/services/bill/types';
import { fromRatingNumber } from '@1bill-app/helpers/general.helper';

/**
 * Page for showing bills with savings information
 * URL: /find-more-savings
 */
@Component({
  selector: 'app-find-more-savings',
  templateUrl: './find-more-savings.page.html',
  styleUrls: ['./find-more-savings.page.scss'],
  animations: [
    trigger('fadeAnimation', [
      transition(':increment', [style({ opacity: 0 }), animate(600)]),
      transition(':decrement', [style({ opacity: 0 }), animate(600)]),
    ]),
  ],
})
export class FindMoreSavingsPage implements OnInit, OnDestroy {
  constructor(
    private homeQuery: HomeQuery,
    private billQuery: BillQuery,
    private billService: BillService,
    private logger: NGXLogger,
    private homeService: HomeService,
    private popoverController: PopoverController,
  ) {}

  subs = new SubSink();
  public isBillLoading$ = this.billQuery.isLoading$;
  public savingsBills$ = this.billQuery.savingsBills$.pipe(
    map((bills) =>
      bills.filter(
        (bill) =>
          (!bill.switchStatus || bill.switchStatus === 'FAILED') &&
          fromRatingNumber(bill.rating) !== BillRating.Excellent,
      ),
    ),
  );
  public loading$ = this.homeQuery.isLoading$;
  homeLoading$ = this.homeQuery.select('loaded').pipe(
    startWith(false),
    switchMap((homeLoaded) => {
      return this.billQuery.select('loaded').pipe(
        startWith(false),
        map((billLoaded) => !billLoaded || !homeLoaded),
      );
    }),
  );

  ngOnInit() {
    this.subscribeAllData();
  }

  subscribeAllData() {
    this.subs.sink = this.homeService.fetchAllData().subscribe();
    this.subs.sink = this.billService.getBill().subscribe();
    this.subs.sink = this.homeService.homeDataEvent$.subscribe((trigger) => {
      if (trigger) {
        this.logger.debug('BillsPage::homeDataEvent$', trigger);
        this.subscribeAllData();
      }
    });
  }

  async presentInfoPopoverFilter() {
    const popover = await this.popoverController.create({
      component: PopoverSimpleComponent,
      cssClass: 'onebill-popover-simple',
      // translucent: true,
      mode: 'ios',
      componentProps: {
        popoverTitle: EXPLANATION_NOTES_SIMPLE.FILTER_BILL_TITLE,
        description: EXPLANATION_NOTES_SIMPLE.FILTER_BILL_DESC,
      },
    });
    return await popover.present();
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
